import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";
import LoaderModule from "./Components/Loader";
import Authenticated from "./Utils/Authenticated";
import "./styles/index.css";

ReactDOM.render(
  <Authenticated
    renderTrue={(user) => <App user={user} />}
    renderFalse={(motif) => (
      motif && motif === 'unauthorized' 
      ? <App unauthorized /> 
      : <App />
    )}
    renderPending={() => <LoaderModule />}
  />,
  document.getElementById("root")
);
